<template>
    <div class="mortgage_wrapper" v-if="getItem">
        <div class="page page1">
            <div class="box box1">{{getItem.station}}</div>
            <div class="box name1">{{getItem.name}}</div>
            <div class="box name2">{{getItem.name}}</div>
            <div class="box box2">乙</div>
            <div class="box box3-1">{{getItem.startDate.year}}</div>
            <div class="box box3-2">{{getItem.startDate.month}}</div>
            <div class="box box3-3">{{getItem.startDate.day}}</div>
            <div class="box box4-1">{{getItem.endDate.year}}</div>
            <div class="box box4-2">{{getItem.endDate.month}}</div>
            <div class="box box4-3">{{getItem.endDate.day}}</div>
            <table class="list1">
                <tr>
                    <td width="80px">{{getItem.carType}}</td>
                    <td width="100px">{{getItem.carId}}</td>
                    <td width="120px">{{getItem.carEngineType}}</td>
                    <td width="70px">{{getItem.vendorId}}</td>
                    <td width="50px">{{getItem.carYear}}</td>
                    <td width="120px">{{getItem.engineId}}</td>
                    <td width="260px">{{getItem.creditPrice}}</td>
                    <td>{{getItem.comment}}</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </table><!--list1-->
            <div class="box box5">
                <p>{{getItem.birthday.year}}/{{getItem.birthday.month}}/{{getItem.birthday.day}}</p>
                <p>{{getItem.city}}{{getItem.area}}{{getItem.address}}</p>
                <p>{{getItem.memberId}}</p>
            </div>
            <div class="box box6-1">{{getItem.startDate.year}}</div>
            <div class="box box6-2">{{getItem.startDate.month}}</div>
            <div class="box box6-3">{{getItem.startDate.day}}</div>
            <!--<div class="box box6-1">{{createDate.getFullYear() - 1911}}</div>-->
            <!--<div class="box box6-2">{{(createDate.getMonth()+1) < 10 ? `0${(createDate.getMonth()+1)}`: (createDate.getMonth()+1)}}</div>-->
            <!--<div class="box box6-3">{{createDate.getDate() < 10 ? `0${createDate.getDate()}` : createDate.getDate()}}</div>-->
        </div><!--page1-->


        <div class="page page2">
            <div class="box name3">{{getItem.name}}</div>
            <div class="box box7-1">{{getItem.endDate.year}}</div>
            <div class="box box7-2">{{getItem.endDate.month}}</div>
            <div class="box box7-3">{{getItem.endDate.day}}</div>
            <div class="box box8">{{getItem.creditPrice}}</div>
            <table class="list2">
                <tr>
                    <td width="135px">{{getItem.carType}}</td>
                    <td width="135px">{{getItem.carId}}</td>
                    <td width="135px">{{getItem.carEngineType}}</td>
                    <td width="130px">{{getItem.vendorId}}</td>
                    <td width="135px">{{getItem.carYear}}</td>
                    <td width="180px">{{getItem.engineId}}</td>
                    <td>{{getItem.comment}}</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </table><!--list2-->
            <div class="box box9">
              <!--{{getItem.birthday.year}}/{{getItem.birthday.month}}/{{getItem.birthday.day}}-->
            </div>
            <div class="box box10">{{getItem.city}}{{getItem.area}}{{getItem.address}}</div>
            <div class="box box11">{{getItem.memberId}}</div>
            <div class="box box12-1">{{getItem.startDate.year}}</div>
            <div class="box box12-2">{{getItem.startDate.month}}</div>
            <div class="box box12-3">{{getItem.startDate.day}}</div>
            <!--<div class="box box12-1">{{createDate.getFullYear() - 1911}}</div>-->
            <!--<div class="box box12-2">{{(createDate.getMonth()+1) < 10 ? `0${(createDate.getMonth()+1)}`: (createDate.getMonth()+1)}}</div>-->
            <!--<div class="box box12-3">{{createDate.getDate() < 10 ? `0${createDate.getDate()}` : createDate.getDate()}}</div>-->

        </div><!--page2-->

    </div><!--wrapper-->
    <div v-else>
        查無資料
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    export default {
        name: "MortgageView",
        data(){
            return {
                item: null,
                createDate: '',
            }
        },
        created(){
          const profileId = this.$route.query.profileId;
          if (profileId){
              this.fetchMortgageInfo({profileId: profileId}).then(results=>{
                  if (results.length){
                      this.item = results[0];
                      console.log(`fetchMortgageInfo ${JSON.stringify(this.item)}`);
                      this.createDate = new Date(this.getItem.createDate);
                      console.log(`createDate ${this.createDate}`);
                  }
              });
          }
        },
        computed: {
            ...mapGetters(['getUserInfo']),
            getItem(){
              return this.item;
            },
        },
        methods: {
            ...mapActions(['fetchMortgageInfo',]),
        }
    }
</script>

<style scoped src="../../assets/css/mortgage_view.css">
</style>



// WEBPACK FOOTER //
// src/pages/web/MortgageView.vue